import { Container, Stack, Button, useMediaQuery } from "@mui/material";
import React, { useState } from "react";
import TechDialog from "./TechDialog";
import { useTranslation } from "react-i18next";

export default function TechsCard({ tech }) {
  const matches = useMediaQuery("(min-width:1024px)");
  const matche = useMediaQuery("(min-width:670px)");
  const [open, setOpen] = useState(false);
  const [data, setData] = useState("");
  const { t } = useTranslation();
  
  const handleReadMore = (selectedData) => {
    setOpen(true);
    setData(selectedData);
  };

  return (
    <div style={{ zIndex: 10, backgroundColor: "white" }}>
      <Stack
        direction={matche ? "row" : "column"}
        sx={{
          alignItems: "center",
          border: "2px solid #64c6c2",
          p: matche ? "20px" : "10px",
          borderRadius: "20px",
          zIndex: 10,
          width: matches ? "90%" : "250px",
          minHeight: matches ? "180px" : "250px",
        }}
      >
        <img
          src={tech.file}
          style={{ height: "100px", width: matches ? "90px" : "150px" }}
        />
        <Stack>
          <Container
            maxWidth="xs"
            sx={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: matches ? "start" : "center",
              alignItems: "center",
            }}
          >
            <Stack>
              <p
                style={{
                  fontWeight: "bold",
                  color: "#6D6D6D",
                  fontSize: "15px",
                  textAlign: matches ? "" : "center",
                }}
              >
                {tech.title}
              </p>
              {
              tech.description !== null &&
              matches ? (
                <p style={{ color: "#6D6D6D" }}>{`${tech.description.substring(
                  0,
                  90
                )} `}</p>
              ) :
              tech.description !== null &&
              !matches ? (
                <p
                  style={{ color: "#6D6D6D", textAlign: "center" }}
                >{`${tech.description.substring(0, 50)} `}</p>
              ): null }
            </Stack>
            { tech.description !== null && tech.description.length > 99 && (
              <Button
                sx={{ bgcolor: "transparent", color: "#64c6c2" }}
                onClick={() =>
                  handleReadMore({
                    file: tech.file,
                    title: tech.title,
                    text: tech.description,
                  })
                }
              >
                {t("read more")}
              </Button>
            )}
          </Container>
        </Stack>
      </Stack>
      <TechDialog open={open} setOpen={setOpen} data={data} />
    </div>
  );
}
